import { CommonModule, NgClass } from '@angular/common';
import {
    Component,
    Signal,
    ViewEncapsulation,
    computed,
    inject,
} from '@angular/core';
import { StriaAlertComponent } from '@stria/components/alert/alert';
import { ToastService } from 'app/shared/services/toast.service';

@Component({
    selector: 'app-toast',
    standalone: true,
    imports: [CommonModule, StriaAlertComponent, NgClass],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './toast.html',
    styles: [
        `
            :host {
                display: block;
            }
        `,
    ],
})
export class ToastComponent {
    private toastService = inject(ToastService);
    toast: Signal<any> = this.toastService.toast;

    /**
     *  Compute Tailwind Classes for Different Positions
     */
    toastPositionClasses = computed(() => {
        const position = this.toast()?.position || 'top-center';

        switch (position) {
            case 'top-left':
                return 'top-[15px] left-[15px]';
            case 'top-right':
                return 'top-[15px] right-[15px]';
            case 'bottom-left':
                return 'bottom-[15px] left-[15px]';
            case 'bottom-right':
                return 'bottom-[15px] right-[15px]';
            case 'bottom-center':
                return 'bottom-[15px] left-1/2 -translate-x-1/2';
            default: // Default to `top-center`
                return 'top-[15px] left-1/2 -translate-x-1/2';
        }
    });
}
